import { useEffect } from 'react';
import { removeEventHostingDraft, removeCreateEventData } from '_utils/localData';

export const clearDraftData = (reset, defaultValues) => {
  removeEventHostingDraft();
  removeCreateEventData();

  if (typeof reset === 'function') {
    reset(defaultValues);
  }
};

export const useClearDraftOnLeave = () => {
  useEffect(() => {
    const handleBeforeUnload = () => {
      clearDraftData();
    };

    window.addEventListener('beforeunload', handleBeforeUnload);

    return () => {
      window.removeEventListener('beforeunload', handleBeforeUnload);
      clearDraftData();
    };
  }, []);
};

export default clearDraftData;
